import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import constants from './slices/appConstantsSlice'
import pendingPublish from '../redux/reducers/PendingPublish'

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    constants,
    pendingPublish,
    ...asyncReducers,
  })
  return combinedReducer(state, action)
}

export default rootReducer
